module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.step.kind !== 'thanks' && _vm.step.kind !== 'welcome') ? _c('button', {
    staticClass: "klickbox-step-button",
    on: {
      "click": function($event) {
        _vm.stepSetActive(_vm.step);
        _vm.modalOpen('duplicate-step')
      }
    }
  }, [_c('i', {
    staticClass: "kp-panel-copy"
  }), _vm._v(" "), _c('span', {
    staticClass: "step-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('general.actions.duplicate')))])]) : _vm._e()
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-758d271e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/steps/list/ButtonDuplicate.vue
 ** module id = 861
 ** module chunks = 1
 **/